import React from "react";
import InputControls from "../../../common/InputControls";
import { ReasonSpecifDetail } from "../../../../../configurations/discoverConfigs/reasonCodes";

const Documents = ({ formData, disableFields }) => (
  <div>
    <h4 className="bold">Documentation details</h4>
    <div className="panel panel-default">
      <div className="panel-body">
        <div id="documentation">
          {ReasonSpecifDetail["all"] &&
            ReasonSpecifDetail["all"].fields &&
            ReasonSpecifDetail["all"].fields.map(
              (field, index) =>
                field && (
                  <InputControls
                    key={index}
                    disableFields={disableFields}
                    field={field}
                    formData={formData}
                  />
                )
            )}
        </div>
      </div>
    </div>
  </div>
);

export default Documents;



// WEBPACK FOOTER //
// ./src/components/discover/newCase/transactionDetail/CreateCaseForms/Documents.js